import * as React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

export default function SponsorHero() {
  return (
    <Box
      id="hero"
      sx={(theme) => ({
        width: "100%",
        backgroundRepeat: "no-repeat",
        backgroundImage:
          "radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 90%), transparent)",
        ...theme.applyStyles("dark", {
          backgroundImage:
            "radial-gradient(ellipse 80% 50% at 50% 50%, hsl(210, 100%, 16%), transparent)",
        }),
      })}
    >
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          pt: { xs: 14, sm: 20 },
          pb: { xs: 5, sm: 5 },
        }}
      >
        <Stack
          spacing={2}
          useFlexGap
          sx={{ alignItems: "center", width: { xs: "100%", sm: "70%" } }}
        >
          <Typography
            variant="h1"
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: "center",
              fontSize: "clamp(3rem, 10vw, 3.5rem)",
            }}
          >
            Nuestros&nbsp;
            <Typography
              component="span"
              variant="h1"
              sx={(theme) => ({
                fontSize: "inherit",
                color: "primary.main",
                ...theme.applyStyles("dark", {
                  color: "primary.light",
                }),
              })}
            >
              patrocinadores
            </Typography>
          </Typography>
          <Typography
            sx={{
              textAlign: "center",
              color: "text.secondary",
              width: { sm: "100%", md: "80%" },
            }}
          >
            Desde la primera edición de ENMICE, la visión y el éxito de nuestros
            eventos y competencias han sido impulsados por la invaluable
            participación de empresas y organizaciones líderes en diversos
            sectores como nuestros patrocinadores oficiales. Estamos
            profundamente agradecidos por el compromiso y la confianza que han
            depositado en ENMICE, permitiéndonos ofrecer experiencias
            enriquecedoras y oportunidades únicas para la nueva generación de
            talento espacial mexicano. {"\n"}Su apoyo continuo ha sido
            fundamental para hacer realidad nuestros proyectos y fomentar la
            pasión por la ciencia, la tecnología y la exploración
            espacial en México.
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
}
